import { Star, Flag, Paperclip, Trash2, Archive } from "lucide-react";

export default function EmailListItem({ email, isSelected, onSelect, onClick, onStar, onFlag }) {
  const fromName = email.from?.name || email.from?.email || "Unknown";
  const subject = email.subject || "(No subject)";
  const date = email.sent_at || email.received_at || "";
  const formattedDate = date ? new Date(date).toLocaleDateString("en-ZA", {
    month: "short", day: "numeric",
  }) : "";
  const hasAttachments = (email.attachments || []).length > 0;

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2.5 border-b border-app cursor-pointer transition-colors group ${
        email.is_read ? "bg-app-card hover:bg-surface-item" : "bg-violet-600/10 hover:bg-violet-600/20"
      } ${isSelected ? "bg-violet-800/40 border-l-2 border-l-violet-500" : ""}`}
      onClick={onClick}
    >
      {/* Checkbox */}
      <input
        type="checkbox"
        checked={isSelected}
        onChange={(e) => { e.stopPropagation(); onSelect(); }}
        className="w-3.5 h-3.5 rounded border-app text-violet-600 focus:ring-violet-500"
      />

      {/* Star */}
      <button
        onClick={(e) => { e.stopPropagation(); onStar?.(); }}
        className={`flex-shrink-0 ${email.is_starred ? "text-amber-400" : "text-app-secondary hover:text-amber-300"}`}
      >
        <Star className="w-3.5 h-3.5" fill={email.is_starred ? "currentColor" : "none"} />
      </button>

      {/* Flag */}
      <button
        onClick={(e) => { e.stopPropagation(); onFlag?.(); }}
        className={`flex-shrink-0 ${email.is_flagged ? "text-red-400" : "text-app-secondary hover:text-red-300"}`}
      >
        <Flag className="w-3 h-3" />
      </button>

      {/* Sender */}
      <div className={`w-28 flex-shrink-0 truncate text-xs ${email.is_read ? "text-app" : "text-app font-semibold"}`}>
        {fromName}
      </div>

      {/* Subject + preview */}
      <div className="flex-1 min-w-0 truncate text-xs">
        <span className={email.is_read ? "text-app" : "text-app font-medium"}>
          {subject}
        </span>
      </div>

      {/* Attachment icon */}
      {hasAttachments && (
        <Paperclip className="w-3 h-3 text-app-secondary flex-shrink-0" />
      )}

      {/* Date */}
      <div className={`w-16 text-right text-[10px] flex-shrink-0 ${email.is_read ? "text-app-secondary" : "text-app font-medium"}`}>
        {formattedDate}
      </div>
    </div>
  );
}
